export const NetworkTagResources = {
  getNetwork: {
    url: "/devices/tag_list",
    asyncActions: {
      init: "getNetworkTag_INIT",
      success: "getNetworkTag_SUCCESS",
      error: "getNetworkTag_ERROR"
    }
  }
};

const initialState = {
  list: undefined,
  links: undefined,
  status: undefined,
  statusText: undefined,
  meta: undefined,
  deleted: undefined,
  edited: undefined,
  hasList: undefined,
  loading: undefined,
  hasError: undefined
};

export function NetworkTag(state = { initialState }, action = {}) {
  const { init, success, error } = NetworkTagResources.getNetwork.asyncActions;

  switch (action.type) {
    case init: {
      return {
        ...state,
        loading: true,
        hasError: undefined
      };
    }

    case success: {
      const {
        data: {
          _jsonapi: { data },
          links,
          meta
        },
        status,
        statusText
      } = action.payload;
      return {
        list: data,
        links,
        status,
        statusText,
        meta,
        deleted: [],
        edited: [],
        hasList: true,
        loading: false,
        hasError: false
      };
    }

    case error: {
      return {
        ...state,
        loading: false,
        hasError: true
      };
    }

    default: {
      return state;
    }
  }
}
